import { render, staticRenderFns } from "./BranchOrderCustomer.vue?vue&type=template&id=ba281f74&"
import script from "./BranchOrderCustomer.vue?vue&type=script&lang=ts&"
export * from "./BranchOrderCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports